module.exports = __webpack_public_path__ + "pigmentace_4_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/pigmentace_4_before_tn.jpg
// module id = 1444
// module chunks = 0